// extracted by mini-css-extract-plugin
export default {"highlight":"HighLightText_highlight__wulLX"};